import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import { Spin } from "antd";

const EditDepartment = ({ editObj, fetchDepartments, onClose, isOpen }) => {
  const [editObjData, setEditObjData] = useState({ Name: "", Code: "" });
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const [empData, setEmpData] = useState([]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (editObj) {
      setEditObjData(editObj);
    }
  }, [editObj]);

  useEffect(() => {
    if (tokenData && superIdData && editObj?.DepartmentId) {
      setloading(true);
      const fetchEmployeesByDept = async () => {
        try {
          const empResponse = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getEmpByDept?departmentid=${editObj?.DepartmentId}&superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${tokenData}`,
                "Content-Type": "application/json",
              },
            }
          );
          const empsData = await empResponse.json();

          if (empsData["status"]) {
            setEmpData(empsData["ResultData"]);
          } else {
            console.log(
              "Failed to fetch eployees by department:",
              empsData.Message
            );
          }
        } catch (error) {
          console.error(
            "Error fetching eployees by department:",
            error.message
          );
        } finally {
          setloading(false);
        }
      };

      fetchEmployeesByDept();
    }
  }, [tokenData, superIdData, editObj?.DepartmentId]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setloading(true);
    if (tokenData && superIdData) {
      if (!editObjData.Name || !editObjData.Code) {
        Swal.fire("Warning", "Please fill in all fields", "warning");
        return;
      }

      const updatedData = {
        departmentid: editObjData.DepartmentId,
        superid: superIdData,
        name: editObjData.Name,
        code: editObjData.Code,
      };
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/department/updatedepartment`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          }
        );
        const result = await response.json();

        if (result && result.status === true) {
          Swal.fire({
            title: "Success",
            text: "Department updated successfully",
            icon: "success",
          }).then(() => {
            // window.location.reload();
            fetchDepartments();
            onClose();
          });
        } else {
          Swal.fire(
            "Error",
            result.message || "Failed to update department",
            "error"
          );
        }
      } catch (error) {
        console.error("Error updating department:", error);
        Swal.fire("Error", "Something went wrong", "error");
      } finally {
        setloading(false);
      }
    }
  };

  const handleSort = (key) => {
    const sorted = [...empData].sort((a, b) => {
      if (typeof a[key] === "number") return a[key] - b[key];
      return a[key].toString().localeCompare(b[key].toString());
    });
    const withSno = sorted.map((item, index) => ({
      ...item,
      sno: index + 1,
    }));

    setEmpData(withSno);
  };

  return (
    <>
      {isOpen && (
        <div>
          {/* {loading && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              zIndex: 1050,
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )} */}

          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightEditDepartment {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditDepartment {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditDepartment {
            width: 32% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightEditDepartment {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightEditDepartment {
            width:15% !important;
          }
        }
        `}
          </style>
          
          {/* Backdrop */}
          <div className="offcanvas-backdrop fade show" onClick={onClose} />
          
          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightEditDepartment"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Edit Department</h4>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <hr />
            <div
              className="d-flex flex-column flex-grow-1"
              style={{ overflow: "hidden" }}
            >
              <div className="offcanvas-body" style={{ overflow: "visible" }}>
                <form onSubmit={handleUpdate}>
                  <div className="content">
                    <div className="row">
                      <div className="col-6">
                        <div>
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={editObjData.Name || ""}
                            onChange={(e) =>
                              setEditObjData({
                                ...editObjData,
                                Name: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div>
                          <label className="form-label">Code</label>
                          <input
                            type="text"
                            className="form-control"
                            value={editObjData.Code || ""}
                            onChange={(e) =>
                              setEditObjData({
                                ...editObjData,
                                Code: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row d-flex justify-content-end mt-3">
                      <div
                        className="col-3 d-flex justify-content-end"
                        style={{ marginRight: "20px" }}
                      >
                        <button
                          type="button"
                          className="btn btn-secondary "
                          onClick={onClose}
                          aria-label="Close"
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col-2 d-flex justify-content-end">
                        <button type="submit" className="btn btn-success">
                          {" "}
                          {loading ? " Saving.." : "Update"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div style={{ overflowY: "auto", flexGrow: 1 }} className="mb-4">
                <h4 className="px-3 pt-3 ">Employee </h4>
                <div className=" brand-table px-3 mt-3">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <table
                      className="table table-striped"
                      style={{ borderSpacing: "0px" }}
                    >
                      <thead>
                        <tr>
                          <th
                            onClick={() => handleSort("sno")}
                            style={{ cursor: "pointer", padding: "5px 8px" }}
                          >
                            No
                          </th>
                          <th
                            onClick={() => handleSort("CardId")}
                            style={{ cursor: "pointer", padding: "5px 8px" }}
                          >
                            Bio Id
                          </th>
                          <th
                            onClick={() => handleSort("UserName")}
                            style={{ cursor: "pointer" }}
                          >
                            Name
                          </th>
                          <th
                            onClick={() => handleSort("Departmentname")}
                            style={{ cursor: "pointer" }}
                          >
                            Dept
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {empData.length ? (
                          empData.map((row, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td title={row.CardId}>
                                  {row.CardId?.length > 12
                                    ? row.CardId.slice(0, 12) + "..."
                                    : row.CardId}
                                </td>
                                <td title={row.UserName}>
                                  {row.UserName?.length > 9
                                    ? row.UserName.slice(0, 9) + "..."
                                    : row.UserName}
                                </td>
                                <td title={row.Departmentname}>
                                  {row.Departmentname?.length > 9
                                    ? row.Departmentname.slice(0, 9) + "..."
                                    : row.Departmentname}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

EditDepartment.propTypes = {
  editObj: PropTypes.object.isRequired,
  fetchDepartments: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default EditDepartment;
